// src/components/SettingsPage.js
import StoreSettings from "./StoreSettings";

export default function SettingsPage() {
  return (
    <div className="fade-in" style={{ maxWidth: 680 }}>
      <div className="card" style={{ marginBottom: 16 }}>
        <StoreSettings />
      </div>
    </div>
  );
}
